import { dateFormat, formatDate, now } from '../../utils/dateUtils';

export const setData = (type: string, payload: any) => ({
	type,
	payload: payload
});

export const changeLoadStatus = (type: string, status: string, correlationId?: string) => ({
	type,
	payload: {
		status,
		timestamp: formatDate(now(), dateFormat.ISO8601),
		correlationId
	}
});
